import {useLazyQuery} from '@apollo/client';
import {ORDERS} from "../orderTypeDefs";

export const useLazyQueryOrders = (options?: any): any => (
  useLazyQuery(ORDERS, options)
);
